var version = "2.6.0-beta.8";
export { version };